import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store/store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/comofunciona',
            name: 'comofunciona',
            component: () => import('./views/ComoFunciona.vue'),
        },
        {
            path: '/guiainterpretacion',
            name: 'guiainterpretacion',
            component: () => import('./views/GuiaInterpretacion.vue'),
        },
        {
            path: '/login/:usuario?/:password?',
            name: 'login',
            component: () => import('./views/Login.vue'),
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import(/* webpackChunkName: "about" */ './views/About.vue'),
            meta: {
                authRequired: true
            }
        },
        // {
        //     path: '/testing',
        //     name: 'testint',
        //     component: () => import('./views/Testing.vue')
        // },
        {
            path: '/companies',
            name: 'companies',
            component: () => import('./views/Companies.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('./views/Users.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/busqueda',
            name: 'busqueda',
            component: () => import('./views/Busqueda.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/languages',
            name: 'languages',
            component: () => import('./views/Languages.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/functions',
            name: 'functions',
            component: () => import('./views/Functions.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/answersets',
            name: 'answersets',
            component: () => import('./views/AnswerSets.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/questionnaires',
            name: 'questionnaires',
            component: () => import('./views/Questionnaires.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/surveys',
            name: 'surveys',
            component: () => import('./views/Surveys.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/surveyselection',
            name: 'surveyselection',
            component: () => import('./views/SurveySelection.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/selectsurveylang',
            name: 'selectsurveylang',
            component: () => import('./views/SelectSurveyLang.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/usersurvey',
            name: 'usersurvey',
            component: () => import('./views/UserSurvey.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/userlogs',
            name: 'userlogs',
            component: () => import('./views/UserLogs.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/userbusinessunits',
            name: 'userbusinessunits',
            component: () => import('./views/UserBusinessUnits.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/administrators',
            name: 'administrators',
            component: () => import('./views/Administrators.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/valuation',
            name: 'valuation',
            component: () => import('./views/Valuation.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/results',
            name: 'results',
            component: () => import('./views/Results.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/reports',
            name: 'reports',
            component: () => import('./views/Reports.vue'),
            meta: {
                authRequired: true
            }
        },
        { path: '/redirect-me', redirect: { name: 'home' } },
        { path: '*', redirect: '/' }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.authRequired)) {
        if (!store.state.idToken) {
            next({
                path: '/'
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;